import { isEmpty, last } from 'lodash';
import { getWaypointList } from '../../api/Missions/mission-operations';

/**
 * Gets the correct location for the map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.location - The default location for the map center.
 * @param {object} [arg.mission={}] - The mission object.
 * @param {boolean} [arg.isPreFlight=false] - A flag to check if we are in the preflight map.
 * @returns {object} The location to use for the map center.
 */
const getMapCenter = ({ location, mission = {}, isPreFlight = false }) => {
  let centerMap = location;
  if (isPreFlight) {
    const waypointList = getWaypointList(mission);
    if (!isEmpty(waypointList)) {
      centerMap = last(waypointList.features);
    }
  }
  return centerMap;
};

export default getMapCenter;
